/**
 * QuickPrompts · AI 助手欢迎页快捷指令区
 *
 * 视觉与行为与 EmptyState 卡片网格共用 PromptCardGrid（layout="list"）。
 *
 * 裁剪规则（仅本组件用，详见 trimForChat）：
 *  · 后端 ≥ 4 项 → 取 4
 *  · 后端 2-3 项 → 取 2（凑不齐 4 时降一档）
 *  · 后端 0-1 项 → 取 0，整个卡片区不渲染（不走 FALLBACK 兜底，让欢迎页只剩 hero + 标题/副标题）
 *
 * 早期版本是横排 chip + 仅文字 + 前端写死 FALLBACK_HEAD/FIXED_TAIL；
 * 后端 /init recommended_prompts 升级为带 icon_type + subtitle 的结构后，
 * 渲染统一收敛到 PromptCardGrid，本组件只剩薄接线层 + 裁剪逻辑。
 */

import React from 'react'
import { useAppSelector } from '../../../../../../app/hooks'
import {
  selectInitLoading,
  selectInitRecommended
} from '../../../../../../slices/aiClassify'
import { trackAIChatClick } from '../../../../utils/trackClassify'
import { trimForChat } from '../../../../utils/recommendedPrompt'
import PromptCardGrid from '../../../PromptCardGrid'

export interface QuickPromptsProps {
  onSelect: (text: string) => void
  disabled?: boolean
}

const QuickPrompts: React.FC<QuickPromptsProps> = ({ onSelect, disabled }) => {
  const initLoading = useAppSelector(selectInitLoading)
  const initRecommended = useAppSelector(selectInitRecommended)

  const trimmed = trimForChat(initRecommended)

  // init 完成且裁剪后无可展示项 → 不渲染（不进 PromptCardGrid 的 FALLBACK 路径）
  if (!initLoading && trimmed.length === 0) {
    return null
  }

  const handleSelect = (text: string) => {
    trackAIChatClick('content', { string1: text })
    onSelect(text)
  }

  return (
    <PromptCardGrid
      prompts={trimmed}
      loading={initLoading}
      onSelect={handleSelect}
      disabled={disabled}
      layout="list"
    />
  )
}

export default QuickPrompts
